import React from 'react';
import { ADD_BLOCKS_MENU_SECTION, ADD_BLOCKS_MENU_SECTION_RANK, CREATE_SYNCED_BLOCK_MENU_ITEM } from '@atlaskit/editor-common/block-menu';
import { CreateSyncedBlockDropdownItem } from './CreateSyncedBlockDropdownItem';
export var getBlockMenuComponents = function getBlockMenuComponents(api) {
  return [{
    type: 'block-menu-item',
    key: CREATE_SYNCED_BLOCK_MENU_ITEM.key,
    parent: {
      type: 'block-menu-section',
      key: ADD_BLOCKS_MENU_SECTION.key,
      rank: ADD_BLOCKS_MENU_SECTION_RANK[CREATE_SYNCED_BLOCK_MENU_ITEM.key]
    },
    component: function component() {
      return /*#__PURE__*/React.createElement(CreateSyncedBlockDropdownItem, {
        api: api
      });
    }
  }];
};